import { render, staticRenderFns } from "./DeviceSettings.vue?vue&type=template&id=2686f932&scoped=true"
import script from "./DeviceSettings.vue?vue&type=script&lang=js"
export * from "./DeviceSettings.vue?vue&type=script&lang=js"
import style0 from "./DeviceSettings.vue?vue&type=style&index=0&id=2686f932&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2686f932",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2686f932')) {
      api.createRecord('2686f932', component.options)
    } else {
      api.reload('2686f932', component.options)
    }
    module.hot.accept("./DeviceSettings.vue?vue&type=template&id=2686f932&scoped=true", function () {
      api.rerender('2686f932', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Settings/Modal/DeviceSettings.vue"
export default component.exports